import { resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-form__item" }
const _hoisted_3 = ["readonly", "min", "max", "maxlength", "minlength", "type", "id", "name", "placeholder", "required", "pattern", "autocomplete"]
const _hoisted_4 = { class: "o-form__validation" }
const _hoisted_5 = { class: "o-form__validation__required" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "o-form__validation__error"
}
const _hoisted_8 = {
  key: 2,
  class: "o-form__validation__error"
}
const _hoisted_9 = {
  key: 3,
  class: "o-form__validation__error"
}
const _hoisted_10 = {
  key: 0,
  class: "o-form__instruction"
}
const _hoisted_11 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass(((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass))
      }, [
        _createVNode(_component_inputlabel, { field: $props.field }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", _mergeProps({
            class: ["o-input", { 'readonly': $props.field.inputReadonly === true }],
            readonly: ($props.field.inputReadonly === true && $props.field.value !== null && $props.field.value != '') ? 'readonly' : false,
            min: ($options.fieldMinValue && String($options.fieldMinValue).trim() != '') ? $options.fieldMinValue : null,
            max: ($options.fieldMaxValue && String($options.fieldMaxValue).trim() != '') ? $options.fieldMaxValue : null,
            maxlength: ($props.field.inputMaxlength && String($props.field.inputMaxlength).trim() != '') ? $props.field.inputMaxlength : null,
            minlength: ($props.field.inputMinlength && String($props.field.inputMinlength).trim() != '') ? $props.field.inputMinlength : null
          }, _toHandlers($data.readOnlyHandlers, true), {
            type: $options.fieldType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.field.value) = $event)),
            id: 'input-'+$props.field.id,
            name: $props.field.inputName,
            placeholder: $props.field.inputPlaceholder,
            required: ($props.field.inputRequired === true) ? 'required' : false,
            pattern: ($props.field.inputPattern && $props.field.inputPattern !='') ? $props.field.inputPattern : null,
            autocomplete: ($props.field.inputAutocomplete && $props.field.inputAutocomplete != '' && $props.field.inputAutocomplete != 'querystring' && $props.field.inputAutocomplete != 'reactivevalue' && $props.field.inputAutocomplete != 'cookie') ? $props.field.inputAutocomplete : false,
            onBlur: _cache[1] || (_cache[1] = $event => ($options.formatValue(this.field.value)))
          }), null, 16 /* FULL_PROPS */, _hoisted_3), [
            [_vModelDynamic, $props.field.value]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
            ($props.field.inputPatternInvalidMessage && String($props.field.inputPatternInvalidMessage).trim()!='')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "o-form__validation__error",
                  innerHTML: $props.field.inputPatternInvalidMessage
                }, null, 8 /* PROPS */, _hoisted_6))
              : ($options.fieldMaxValue !== null && parseFloat($props.field.value) > parseFloat($options.fieldMaxValue))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx._t('La valeur entrée doit être inférieure ou égale à')) + " " + _toDisplayString($options.fieldMaxValue) + ". ", 1 /* TEXT */))
                : ($options.fieldMinValue !== null && parseFloat($props.field.value) < parseFloat($options.fieldMinValue))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx._t('La valeur entrée doit être supérieure ou égale à')) + " " + _toDisplayString($options.fieldMinValue) + ". ", 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */))
          ])
        ]),
        ($props.field.inputInstructions && String($props.field.inputInstructions).trim() != '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createElementVNode("small", {
                innerHTML: $props.field.inputInstructions
              }, null, 8 /* PROPS */, _hoisted_11)
            ]))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}